import 'reflect-metadata';
import { jsonProperty, Serializable } from 'ts-serializable';

import { FixedTypeModel } from './FixedTypeModel';

export class DocumentFixedTypeModel extends Serializable {
  @jsonProperty(FixedTypeModel) fixedType: FixedTypeModel | null = null;
  @jsonProperty(Boolean) isMulti: boolean = false;
  @jsonProperty(Boolean) isRequired: boolean = false;
  @jsonProperty(Boolean) isEnabled: boolean = false;
  @jsonProperty(Boolean) isImage: boolean = false;
  @jsonProperty(Boolean) hasFiles: boolean = false;
  @jsonProperty(Boolean) isReadOnly: boolean = false;
}
